import {Component, HostBinding, OnDestroy, OnInit, signal, WritableSignal} from '@angular/core';
import {AuthService, AuthUserType} from "../../../../../modules/auth";
import {LocaleService} from "../../../../../i18n/service/locale.service";
import {AVAILABLE_LANGUAGES} from "../../../../../../_config/languages";
import {LanguageFlag} from "../../../../../i18n/interface";


@Component({
  selector: 'app-user-inner',
  templateUrl: './user-inner.component.html',
})
export class UserInnerComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  class = `menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px`;
  @HostBinding('attr.data-kt-menu') dataKtMenu = 'true';

  language: LanguageFlag;
  langs = AVAILABLE_LANGUAGES;

  userData: WritableSignal<AuthUserType> = signal(undefined);


  constructor(
    private auth: AuthService,
    private localeService: LocaleService
  ) {
  }

  ngOnInit(): void {
    this.userData = this.auth.currentUser;
    this.initDropdownLanguage(this.localeService.currentLocale);
  }

  async logout() {
    await this.auth.logout({reloadPage: true, redirectToCurrentUrl: false});
  }

  onSelectLanguage(lang: string) {
    this.localeService.setLocale(lang);
    this.initDropdownLanguage(lang);
  }

  initDropdownLanguage(lang: string) {
    this.langs.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
  }

  ngOnDestroy() {
  }
}
